import { LOAD } from "./types";

export const loadPlan = (payload) => ({ type: LOAD, payload });
